import { useState } from 'react';
import SpinnerIcon from '@/components/icons/SpinnerIcon';
import { PhotoIcon } from '@heroicons/react/24/outline';

interface ImageWithPlaceholderProps {
  src: string;
  alt?: string;
}

const ImageWithPlaceholder = ({ src, alt }: ImageWithPlaceholderProps) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  return (
    <div className="w-full min-h-[200px] h-full flex items-center justify-center bg-gray-50 relative">
      {loading && !error && (
        <SpinnerIcon className="w-10 h-10 text-gray-400 animate-spin absolute" />
      )}
      {!error ? (
        <img
          src={src}
          alt={alt}
          className={`w-full h-auto max-h-[80vh] object-contain ${loading ? 'opacity-0' : 'opacity-100'} transition-opacity`}
          onLoad={() => setLoading(false)}
          onError={() => {
            setLoading(false);
            setError(true);
          }}
        />
      ) : (
        <div className="flex flex-col items-center justify-center text-gray-400">
          <PhotoIcon className="w-12 h-12 mb-2" />
          <span>Failed to load image</span>
        </div>
      )}
    </div>
  );
};

export default ImageWithPlaceholder;
